/**
 * Készlet / rendelhetőség segédek.
 *
 * A backend kétféle dolgot ad vissza:
 *  - fizikai polckészlet: `in_stock`, `stock_quantity` (belső számok)
 *  - rendelhetőség:       `is_orderable`, `availability_note`
 *
 * Utánrendeléssel (alapértelmezett) egy 0 polckészletű variáns is rendelhető,
 * a beszállító +1-2 nap alatt szállít. A vásárlást ezért az `is_orderable`
 * kapuzza; a polckészlet csak a mennyiség-plafont adja.
 */

interface StockSource {
  in_stock: boolean;
  stock_quantity: number;
  /** Régi (localStorage) pillanatképeken hiányozhat; akkor in_stock-ra esünk vissza. */
  is_orderable?: boolean;
}

/**
 * Egy kosársor felső mennyiségi korlátja.
 *
 *  - nem rendelhető (variáns, ha van, különben termék) → 0
 *  - van polckészlet → `available_stock` (szerver) vagy `stock_quantity`
 *  - nincs polckészlet, de rendelhető (utánrendelés) → Infinity
 *
 * A hívó `Number.isFinite(max)`-szal döntse el, kell-e egyáltalán plafonozni.
 */
export function cartLineMax(item: {
  product: StockSource;
  product_variant?: StockSource | null;
  available_stock?: number;
}): number {
  const source = item.product_variant ?? item.product;
  const orderable = source.is_orderable ?? source.in_stock;
  if (!orderable) return 0;
  if (source.in_stock) return item.available_stock ?? source.stock_quantity;
  return Infinity;
}
